import * as React from 'react'
// libs
import { ComposerPrimitive, useAui, useAuiState } from '@assistant-ui/react'
// icons
import AddIcon from '@mui/icons-material/Add'
import SendIcon from '@mui/icons-material/ArrowUpward'
import StopIcon from '@mui/icons-material/Stop'
// context
import { ChatActionsContext } from '../../../../ChatRuntimeProvider'
// utils
import { ALLOWED_MIME_TYPES } from 'utils/validators'
// components
import AttachmentChip from '../AttachmentChip'
// views
import {
  FileInput,
  InputWrapper,
  AttachButton,
  AttachedFilesRow,
  StyledSendButton,
  StyledCancelButton,
  ComposerDisclaimer,
  StyledComposerRoot,
  StyledComposerInput
} from './views'

const ComposerArea: React.FC = () => {
  const aui: any = useAui()
  const hasAttachments = useAuiState((s: any) => (s.composer.attachments ?? []).length > 0)
  const isRunning = useAuiState((s: any) => s.thread.isRunning as boolean)

  const { isSummarising, isLoadingMessages } = React.useContext(ChatActionsContext)

  const isComposerDisabled = isSummarising || isLoadingMessages

  const fileInputRef = React.useRef<HTMLInputElement>(null)

  const handleAttachClick = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? [])

    if (files.length === 0) {
      return
    }

    for (const file of files) {
      await aui.composer().addAttachment(file)
    }

    e.target.value = ''
  }

  return (
    <>
      <StyledComposerRoot $disabled={isComposerDisabled}>
        {hasAttachments && (
          <AttachedFilesRow>
            <ComposerPrimitive.Attachments components={{ Attachment: AttachmentChip }} />
          </AttachedFilesRow>
        )}
        <InputWrapper>
          <FileInput
            multiple
            type='file'
            ref={fileInputRef}
            onChange={handleFileChange}
            accept={ALLOWED_MIME_TYPES.join(',')}
          />
          {/*<AttachButton type='button' onClick={handleAttachClick}>*/}
          {/*  <AddIcon fontSize='small' />*/}
          {/*</AttachButton>*/}
          <StyledComposerInput placeholder='Type a message...' disabled={isComposerDisabled} />
          {!isComposerDisabled && (
            <StyledSendButton>
              <SendIcon fontSize='small' />
            </StyledSendButton>
          )}
          {isRunning && !isSummarising && (
              <StyledCancelButton>
                <StopIcon fontSize='small' />
              </StyledCancelButton>
            )}
        </InputWrapper>
      </StyledComposerRoot>
      <ComposerDisclaimer>rAI can make mistakes. Check important info.</ComposerDisclaimer>
    </>
  )
}

export default ComposerArea
